module.exports = __webpack_public_path__ + "img/founder1.a25b8b0a.jpg";